import { Order } from '../../types/orders';
import { Actions, ActionTypes } from './actions';
import { OperationResponseError, OperationLineItem, AuthorizationGroup } from '../types';
import { UiState } from './types';

export interface State {
    order: Order | undefined;
    authorizationGroup: AuthorizationGroup | undefined;
    state: UiState;
    error: OperationResponseError | undefined;
    operationLineItems: OperationLineItem[];
}

export const initialState: State = {
    state: UiState.Inactive,
    order: undefined,
    error: undefined,
    operationLineItems: [],
    authorizationGroup: undefined,
};

export function reducer(state: State = initialState, action: Actions) {
    switch (action.type) {
        case ActionTypes.Open:
            return {
                ...initialState,
                state: UiState.Form,
                order: action.payload.order,
                authorizationGroup: action.payload.authorizationGroup,
            };

        case ActionTypes.Dismiss:
            return initialState;

        case ActionTypes.InvokeRequest:
            return {
                ...state,
                state: UiState.InFlight,
                operationLineItems: action.payload.items,
            };

        case ActionTypes.SuccessResponse:
            return {
                ...state,
                state: UiState.Success,
            };

        case ActionTypes.ErrorResponse:
            return {
                ...state,
                state: UiState.Error,
                error: {
                    code: action.payload.code,
                    message: action.payload.message,
                    errors: action.payload.errors,
                },
            };

        default:
            return state;
    }
}
